import gql from "graphql-tag";
import { COMPANY_FRAGMENT } from "../company/fragments";
import { USER_FRAGMENT } from "../user/fragment";

export const COMPANY_INFO_PAPPERS = gql`
  query FetchCompanyPappers($siret: String, $documentTypes: [String]) {
    fetchCompanyPappers(siret: $siret, documentTypes: $documentTypes) {
      company {
        ...CompanyInfo
      }
      representatives {
        ...UserInfo
      }
      ubo {
        ...UserInfo
      }
    }
  }
  ${COMPANY_FRAGMENT}
  ${USER_FRAGMENT}
`;
